// @ts-ignore
import ColorPalettesData from "../../content/colorSchemes.yaml"

interface Theme {
  breakpoints: {
    md: string
    lg: string
  }
  colorPalettes: {
    blue: ColorPalette
    green: ColorPalette
    pink: ColorPalette
    aqua: ColorPalette
    purple: ColorPalette
  }
}

export interface ColorPalette {
  navTop: string
  navBottom: string
  navButton: string
  subNav?: string
  heroTop: string
  heroBottom: string
  heroRibbon: string
  buttonNew: string
  buttonText: string
  sectionText: string
  cardAccentTop: string
  cardAccentBottom: string
  textColor: string
}

export const theme: Theme = {
  breakpoints: {
    md: "576px",
    lg: "768px",
  },
  colorPalettes: ColorPalettesData,
}
